import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[gtwClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {

  @Output('gtwClickOutside') clickOutside = new EventEmitter<'outside'>();

  constructor(private elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event'])
  public onClick(event: MouseEvent) {
    const hostEl = this.elementRef?.nativeElement as HTMLElement | null;
    const target = event.target as Node | null;
    if (!hostEl || !target) {
      return;
    }

    let clickedInside = hostEl.contains(target);

    if (!clickedInside && typeof event.composedPath === 'function') {
      clickedInside = event.composedPath().some(el => el === hostEl);
    }

    if (!clickedInside) {
      const activeEl = document.activeElement as HTMLElement | null;
      if (activeEl && hostEl.contains(activeEl)) {
        activeEl.blur();
      }
      this.clickOutside.emit('outside');
    }
  }

}
